module.exports = __webpack_public_path__ + "img/connected-art.4bd4d255.svg";